import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { errMsg } from "../crm/crmUtil";

// Server-side render of the draft with sample values (nothing is saved). Debounced while typing.
export default function TemplatePreview({ body }) {
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!body.trim()) { setRes(null); return undefined; }
    const t = setTimeout(() => {
      api.post("/sales/contract-templates/preview", { body }).then((r) => { setRes(r.data); setErr(""); }).catch((x) => setErr(errMsg(x)));
    }, 400);
    return () => clearTimeout(t);
  }, [body]);
  return (
    <section className="border border-erf-borderCream rounded bg-white p-3 min-w-0" aria-labelledby="tpl-prev-title" data-testid="tpl-preview">
      <h3 id="tpl-prev-title" className="text-xs uppercase font-nav text-erf-dark/60 mb-2">Preview (sample values)</h3>
      {err && <p role="alert" className="text-sm text-red-700" data-testid="tpl-preview-error">{err}</p>}
      {res?.unknown_fields?.length > 0 && (
        <p role="alert" className="text-sm text-red-700 mb-2" data-testid="tpl-preview-unknown">
          Unknown merge fields (saving is refused): {res.unknown_fields.join(", ")}
        </p>
      )}
      {res ? <pre className="whitespace-pre-wrap break-words text-sm font-sans" data-testid="tpl-preview-text">{res.text}</pre>
        : <p className="text-sm text-erf-dark/60">Start typing to see the preview.</p>}
    </section>
  );
}
